module.exports = __webpack_public_path__ + "img/profile-checked.7be383a6.svg";